import * as React from 'react';
const { useState } = React;
const h = React.createElement;
import { icons } from '../icons';
import { Button } from './Button';

export interface EditableCellProps {
  value?: React.ReactNode;
  onEdit?: () => void;
}

const EditableCell: React.FC<EditableCellProps> = function EditableCell(props) {
  const { value, onEdit } = props;
  const [isHovered, setIsHovered] = useState(false);

  return h(
    'div',
    {
      className: 'flex items-center gap-2 min-h-[32px]',
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false),
    },
    h(
      'span',
      { className: 'flex-1 min-w-0 overflow-hidden text-ellipsis whitespace-nowrap' },
      value,
    ),
    isHovered &&
      h(
        'span',
        { className: 'w-7 shrink-0' },
        h(
          Button,
          {
            type: 'text',
            size: 'small',
            onClick: onEdit,
            className: '!p-0 !h-5 !w-5',
          },
          h(icons.EditOutlined, { size: '0.7em' }),
        ),
      ),
  );
};

export { EditableCell };
